import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WatermarkTemplateComplete } from '../../fragments/generated/watermark_templates';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AddWatermarkTemplateMutationVariables = Types.Exact<{
  input: Types.CreateWatermarkTemplateInput;
}>;


export type AddWatermarkTemplateMutation = { __typename?: 'Mutation', createWatermarkTemplate?: { __typename?: 'CreateWatermarkTemplatePayload', watermarkTemplate?: { __typename?: 'WatermarkTemplate', id: string, deletedAt?: string | null, inUse: boolean, name: string, blocks?: Array<{ __typename?: 'WatermarkBlock', alpha?: number | null, fontSize?: Types.WatermarkFontSize | null, name?: string | null, position?: Types.WatermarkPosition | null, positionReferencePoint?: Types.WatermarkPosition | null, positionX?: number | null, positionY?: number | null, rotation?: number | null, scrollText?: Types.WatermarkScrollText | null, textAlignment?: Types.WatermarkTextAlignment | null, textColor?: string | null, textShadow?: boolean | null, dataPoints?: Array<{ __typename?: 'WatermarkDataPointCustomText', value?: string | null } | { __typename: 'WatermarkDataPointEmail' } | { __typename: 'WatermarkDataPointIpAddress' } | { __typename: 'WatermarkDataPointTimestamp' } | { __typename: 'WatermarkDataPointUserInput' } | { __typename: 'WatermarkDataPointUserName' } | null> | null } | null> | null } | null } | null };


export const AddWatermarkTemplate = /*#__PURE__*/ gql`
    mutation AddWatermarkTemplate($input: CreateWatermarkTemplateInput!) {
  createWatermarkTemplate(input: $input) {
    watermarkTemplate {
      ...WatermarkTemplateComplete
    }
  }
}
    ${WatermarkTemplateComplete}` as unknown as DocumentNode<AddWatermarkTemplateMutation, AddWatermarkTemplateMutationVariables>;

          

          export const useAddWatermarkTemplateMutation = (options?:MutationHookOptions<AddWatermarkTemplateMutation, AddWatermarkTemplateMutationVariables>) => useMutation(AddWatermarkTemplate, options);
          

          export type AddWatermarkTemplateMutationOptions = MutationHookOptions<AddWatermarkTemplateMutation, AddWatermarkTemplateMutationVariables>;

          

          export type AddWatermarkTemplateMutationResult = ReturnType<typeof useAddWatermarkTemplateMutation>[1];

          
